import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { LUTON_PROPERTIES_META } from "./meta.ts";
import { buildSearchUrl } from "./runtime.ts";

export * from "./meta.ts";
export * from "./runtime.ts";

export const LUTON_PROPERTIES_ADAPTER = defineSoldOnlyAdapter(
  LUTON_PROPERTIES_META,
  buildSearchUrl,
);
